import { render, staticRenderFns } from "./addHelp.vue?vue&type=template&id=835619aa&scoped=true"
import script from "./addHelp.vue?vue&type=script&lang=js"
export * from "./addHelp.vue?vue&type=script&lang=js"
import style0 from "./addHelp.vue?vue&type=style&index=0&id=835619aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835619aa",
  null
  
)

export default component.exports